module.exports = __webpack_public_path__ + "7e3d8cdbcb8a79852a5e597cfa420e42.svg";